export const msalConfig = {
    auth: {
      clientId: "07e4d64a-9ddc-45be-9b6d-b40682e4a72f",
      authority: "https://login.microsoftonline.com/b5b66d0f-c562-4c91-bb19-e59a13317aab", // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
      redirectUri: "https://runwayadmin.aims360runway.com",
    },
    cache: {
      cacheLocation: "sessionStorage", // This configures where your cache will be stored
      storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    }
  };
  
  // Add scopes here for ID token to be used at Microsoft identity platform endpoints.
  export const loginRequest = {
   scopes: ["User.Read"]
  };
  
  // Add the endpoints here for Microsoft Graph API services you'd like to use.
  export const graphConfig = {
      graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
  };